"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_icon_n_1 = __importStar(require("@gerenciatd/next.components.icon-n"));
const next_components_text_info_n_1 = __importStar(require("@gerenciatd/next.components.text-info-n"));
const PikolinHeader = ({ baseUrl, backLink, leftIconId, rightIconID }) => {
    const taggingInfo = {
        componentContent: '',
        componentName: 'header',
        componentPerso: '',
        componentProduct: '',
        componentVariation: 'all',
    };
    const renderLinkContent = ({ link, content, componentName, componentContent, }) => {
        return (react_1.default.createElement(next_components_custom_link_1.default, { component: "a", href: link, isExternal: true, taggingInfo: Object.assign(Object.assign({}, taggingInfo), { componentName,
                componentContent }) }, content));
    };
    return (react_1.default.createElement("div", { className: "nextHeader" },
        react_1.default.createElement("div", { className: "container headerContainer" },
            react_1.default.createElement("div", { className: "LogoGap" }, baseUrl &&
                baseUrl.link &&
                renderLinkContent({
                    isExternal: true,
                    link: baseUrl.link,
                    componentName: 'logoMovistar',
                    componentContent: `Ir-a-${baseUrl.link}`,
                    content: (react_1.default.createElement(next_components_icon_n_1.default, { id: leftIconId, size: 44, color: next_components_icon_n_1.ICON_COLOR.BLUE, kind: next_components_icon_n_1.ICON_KIND.SOLID, className: "LogoM" })),
                })),
            react_1.default.createElement("div", { className: "MainTitle" },
                react_1.default.createElement(next_components_text_info_n_1.default, { kind: next_components_text_info_n_1.TEXT_INFO_KIND.SPAN, className: "menuTitle", color: next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_7, size: next_components_text_info_n_1.TEXT_INFO_SIZE.TITLE5, fontType: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.LIGHT, text: "mi" }),
                react_1.default.createElement(next_components_text_info_n_1.default, { kind: next_components_text_info_n_1.TEXT_INFO_KIND.SPAN, className: "menuTitle", color: next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_7, size: next_components_text_info_n_1.TEXT_INFO_SIZE.TITLE5, fontType: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.LIGHT, text: "Movistar" })),
            react_1.default.createElement("div", { className: "BackGap" }, backLink &&
                backLink.link &&
                renderLinkContent({
                    isExternal: backLink.isExternal,
                    link: backLink.link,
                    componentName: 'CheuronIzq',
                    componentContent: `Ir-a-${backLink.link}`,
                    content: (react_1.default.createElement("div", { className: "LinkContent" },
                        react_1.default.createElement(next_components_text_info_n_1.default, { className: "backTitle", kind: next_components_text_info_n_1.TEXT_INFO_KIND.SPAN, color: next_components_text_info_n_1.TEXT_INFO_COLOR.BLACK, size: next_components_text_info_n_1.TEXT_INFO_SIZE.TITLE7, fontType: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.LIGHT, text: backLink.label }),
                        react_1.default.createElement(next_components_icon_n_1.default, { id: rightIconID, color: next_components_icon_n_1.ICON_COLOR.WHITE, kind: next_components_icon_n_1.ICON_KIND.MEDIUM, className: "MenuCerrar", size: 12 }))),
                })))));
};
PikolinHeader.prototype = {
    backLink: prop_types_1.default.object,
    baseUrl: prop_types_1.default.object,
    leftIconId: prop_types_1.default.string,
    rightIconID: prop_types_1.default.string,
};
PikolinHeader.defaultProps = {
    backLink: {
        label: 'Cerrar',
        isExternal: true,
        link: 'https://www.movistar.es/particulares/mimovistar/',
    },
    baseUrl: {
        isExternal: true,
        link: 'https://www.movistar.es',
    },
    leftIconId: next_components_icon_n_1.ICON_ID.Movistar,
    rightIconID: next_components_icon_n_1.ICON_ID.Cerrar,
};
exports.default = PikolinHeader;
//# sourceMappingURL=index.js.map